<template>

  <div class="quiz__step" id="step-2">
    <div class="quiz__tab-item-wrap">
      <div class="quiz__aside">

        <btn-back
            :text="translate.masterBackText"
            @backToStep="backToStep"
        />

        <div v-for="material in materials" :key="material.id+'mq2'">
          <div class="quiz-checks checks-for-material" v-show="materialParam == material.value" data-material="{{ material.value }}" >

            <div v-for="variant in getVariants(material.variants, 'two')" :key="variant.id">
              <label class="radio" :class="variant.value == dielectric ? 'checked' : ''">
                <input type="radio" v-model="dielectric" name="step-2" :value="variant.value" class="param-{{ variant.id }}" />
                <div class="radio__text">{{ variant.name }}</div>
              </label>
            </div>

          </div>
        </div>


      </div>
      <div class="quiz__content">

        <div v-if="isLiquid && texts && texts.textStep2" v-html="texts.textStep2">
        </div>
        <div v-if="isLoose && texts && texts.wetText" v-html="texts.wetText">
        </div>

      </div>
    </div>

  </div>

</template>

<script>
import BtnBack from "../BtnBack.vue";
export default {
  name: "dielectricConstant",
  components: {BtnBack},
  props: ['translate', 'materials', 'materialParam', 'stepTwo', 'isLiquid', 'isLoose', 'texts'],
  computed:{
    dielectric:{
        get(){
            return this.stepTwo;
        },
        set(newVal){
            this.$emit('changeDielectric', newVal)
        }
    }
  },

  methods:{
    backToStep(){
      this.$emit('backToStep')
    },
    getVariants(variants, name){
      return (variants.filter(element => element.step == name));
    },
  }
}
</script>

<style scoped>

</style>